export const helpLink = 'https://ajuda.terrainvestimentos.com.br/';

export const baseBankAccount = {
    bank: '307 - Terra Investimentos DTVM',
    agency: '0001',
};
